import { render } from "./BCorp.vue?vue&type=template&id=42cbb6ee&scoped=true"
import script from "./BCorp.vue?vue&type=script&lang=js"
export * from "./BCorp.vue?vue&type=script&lang=js"

import "./BCorp.vue?vue&type=style&index=0&id=42cbb6ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cbb6ee"]])

export default __exports__